export default "__VITE_ASSET__Ca0ZF70q__"